/**
 * Program assignments (client view) – list my assigned programs.
 */
import { collection, query, where, orderBy, getDocs, limit } from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'programAssignments';

export async function listByClient(clientId, limitCount = 50) {
  const q = query(
    collection(db, COLLECTION),
    where('clientId', '==', clientId),
    orderBy('startDate', 'desc'),
    limit(limitCount)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function getByClientAndProgram(clientId, programId) {
  const q = query(
    collection(db, COLLECTION),
    where('clientId', '==', clientId),
    where('programId', '==', programId),
    limit(1)
  );
  const snap = await getDocs(q);
  if (snap.empty) return null;
  return { id: snap.docs[0].id, ...snap.docs[0].data() };
}

export const programAssignmentRepo = { listByClient, getByClientAndProgram };
